import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import './index.css';

const { Header: AntHeader } = Layout;

// 创建一个内部组件来使用useLocation hook
const HeaderContent = () => {
  const location = useLocation();
  
  const items = [
    {
      key: '/',
      label: <Link to="/">首页</Link>,
    },
    {
      key: '/archives',
      label: <Link to="/archives">归档</Link>,
    },
    {
      key: '/write-post',
      label: <Link to="/write-post">写文章</Link>,
    },
    {
      key: '/my',
      label: <Link to="/my">我的</Link>,
    },
  ];

  // 确定当前激活的菜单项
  const getCurrentMenuKey = () => {
    if (!location) return '/';
    if (location.pathname === '/') return '/';
    if (location.pathname.startsWith('/archives')) return '/archives';
    if (location.pathname.startsWith('/write-post')) return '/write-post';
    if (location.pathname.startsWith('/my')) return '/my';
    if (location.pathname.startsWith('/post')) return '/'; // 文章详情页也视为首页相关
    return '/';
  };

  return (
    <>
      <div className="logo">
        <Link to="/">我的博客</Link>
      </div>
      <Menu
        theme="light"
        mode="horizontal"
        items={items}
        selectedKeys={[getCurrentMenuKey()]}
        className="center-menu"
      />
      <div className="header-placeholder"></div>
    </>
  );
};

const Header = () => {
  // HeaderContent 组件只有在 Router 内部才会被渲染
  // 这样可以保证 useLocation 总是在 Router 上下文中被调用
  return (
    <AntHeader className="header">
      <HeaderContent />
    </AntHeader>
  );
};

export default Header;